/*
 * Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
 *
 * This SOURCE CODE FILE, which has been provided by Certusoft as part
 * of a Certusoft product for use ONLY by licensed users of the product,
 * includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
 *
 * USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
 * OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
 * THE PRODUCT.
 */

import { Injectable } from '@angular/core'
import { Role } from '../models/clikcrm/RBAC'
import * as _ from 'lodash'

@Injectable({
    providedIn: 'root',
})
export class UserSessionService {
    constructor() {}
    public id: string = ''
    public userId: string = ''
    public userRoles: Array<Role> = []
    public salesPersonModel: any = {}
    public selectedDealer: any = {}
    public sessionExpiration: number = -1
    public crmAccounts: Array<any> = []

    create(sessionId: string, userId: string, userRoles: Array<Role>, sessionExpiration: number | null) {
        this.id = sessionId
        this.userId = userId
        this.userRoles = userRoles
        this.sessionExpiration = sessionExpiration || Date.now() + 8 * 60 * 60 * 1000
    }

    hasRole(roleName: string) {
        let self = this
        let userRoles: Array<Role> = self.userRoles
        //_.map(userRoles, 'name').includes(roleName);
        _.includes(_.map(userRoles, 'name'), roleName)
    }
    destroy() {
        let self = this
        self.id = ''
        self.userId = ''
        self.userRoles = []
        self.crmAccounts = []
        self.sessionExpiration = 0
    }
}
